import React from 'react';

import styles from './index.module.scss';
import { PieChart, Pie, Legend, Cell, Tooltip } from 'recharts';

const CustomPieChart = (props) => (
    <PieChart className={styles.CustomPieChart} width={400} height={400}>
        <Pie
            nameKey="name"
            dataKey="total"
            data={props.data}
            cx="50%"
            cy="40%"
            fill="#8884d8"
            outerRadius={100}
            labelLine={false}
            label={(entry) => {
                if (entry.total > 0) {
                    return entry.name;
                }
            }}
            onClick={(entry)=> props.onClick(entry.field)}
        >
            {props.data
                .filter(entry => entry.total > 0)
                .map((entry) => <Cell fill={entry.color} />)}
        </Pie>
        <Legend />
        <Tooltip />
    </PieChart>
);

export default CustomPieChart;